module.exports = __webpack_public_path__ + "media/trendings/trending-reco-83c2789d.gif";